// extracted by mini-css-extract-plugin
export default {"layout":"Routes_layout__QH6PI","mainContent":"Routes_mainContent__ljIAQ","content":"Routes_content__4+8We"};